// extracted by mini-css-extract-plugin
export default {"top-section":"_i3kc8z","topSection":"_i3kc8z","app-icon":"_16pkjin","appIcon":"_16pkjin"};